import { useCallback } from 'react';
import { MediaProps } from 'components/Media';

import { MediaPercentageProps, useBreakpoint } from '@savebetter/components';
interface UseMediaPercentagePropsReturn {
  getMediaProps: (media: MediaProps) => MediaPercentageProps;
}

export const useMediaPercentageProps = (): UseMediaPercentagePropsReturn => {
  const currentBreakpoint = useBreakpoint();

  return {
    getMediaProps: useCallback(
      (media: MediaProps) => {
        const mediaProps: MediaPercentageProps = {
          loading: 'lazy',
          src: '',
          alt: ''
        };
        if (media) {
          if (currentBreakpoint === 'sm' && media.mobileImg) {
            mediaProps.src = media.mobileImg;
          } else {
            mediaProps.src = media.img;
          }
          mediaProps.alt = media.alt ? media.alt : '';
        }
        return mediaProps;
      },
      [currentBreakpoint]
    )
  };
};
